<template>
<!-- 升级任务与配置任务组件 -->
  <div>
    <el-dialog :title="title" :visible.sync="centerDialogVisible" width="40%" center>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.FutureTask')}}：</span>
        <el-input size="mini" class="adduserinput" v-model="addtaskname"
        :placeholder="$t('lang.taskDialog.provide')"></el-input>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.TaskStatus')}}：</span>
        <el-input size="mini" class="adduserinput" v-model="addtaskms"
        :placeholder="$t('lang.taskDialog.reassign_task_to')"></el-input>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group1')}}：</span>
        <el-select v-model="Grouping1" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini"
        @change="getGroupList2">
          <el-option
            v-for="item in Grouplist"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group2')}}：</span>
        <el-select v-model="Grouping2" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini"
        @change="getGroupList3">
          <el-option
            v-for="item in Groupinglist2"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.group3')}}：</span>
        <el-select v-model="Grouping3" :placeholder="$t('lang.taskDialog.please')" class="adduserinput"
        filterable size="mini" @change="getGroupList3devices">
          <el-option
            v-for="item in Groupinglist3"
            :key="item.group_id"
            :label="item.group_name"
            :value="item.group_id"
          ></el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.taskDialog.Equipment')}}：</span>
        <el-select
          v-model="deviceDid"
          multiple
          filterable
          remote
          :remote-method="remoteMethod"
          collapse-tags
          :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini">
          <el-option
          v-for="item in deviceslist"
          :key="item.deviceDid"
          :label="item.deviceSn + ` (${item.deviceName ? item.deviceName : 'N/A'})`"
          :value="item.deviceDid">
          </el-option>
        </el-select>
      </div>
      <div class="dialog-con">
        <span class="tetxp">{{$t('lang.upgrade.file')}}：</span>
        <el-select v-model="pack" filterable :placeholder="$t('lang.taskDialog.please')" class="adduserinput" size="mini"
        @change="getpackpz">
          <el-option
            v-for="item in packlist"
            :key="item.cfId"
            :label="item.cfName"
            :value="item.cfId"
          ></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="centerDialogVisible = false">{{$t('lang.taskDialog.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="addLevelUp">{{$t('lang.taskDialog.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 任务组件  --接收两个按钮，弹框标题 软件包列表 
import { addLevelUp,addConfig,findCanLevelUp,GroupDevices,getAddLevel3Group } from '@/api/task'
export default {
  props:{
    title:{
      type:String
    },
    packlist:{
      type:Array,
      default:()=>{
        return []
      }
    },
    radio:{
      type:String
    }
  },
  data() {
    return {
      //显示隐藏弹出框
      centerDialogVisible: false,
      // 一二三级分组选中值
      Grouping1:null,
      Grouping2:null,
      Grouping3:null,
      // 二三级分组列表
      Groupinglist2:[],
      Groupinglist3:[],
      // 任务名
      addtaskname:'',
      // 任务描述
      addtaskms:'',
      value:[],
      // 设备列表
      deviceslist:[],
      // 选中的文件数据
      pack:null,
      // 选中的设备
      deviceDid:null,
      //上传的文件信息
      uppack:null,
      //一级分组列表
      Grouplist:[],
      // 当前gid
      defaultGroupId:undefined
    }
  },
  methods:{
    //显示弹出层
    showDialog(){
      //显示弹出层时清空上次选中
      this.uppack=null
      this.pack=null
      this.addtaskname=''
      this.addtaskms=''
      this.value=[]
      this.Grouping1=null
      this.Grouping2=null
      this.Grouping3=null
      this.deviceDid=null
      this.Groupinglist2=[]
      this.Groupinglist3=[]
      this.Grouping2=null
      this.Grouping3=null
      this.deviceslist=[]
      setTimeout(()=>{
        getAddLevel3Group(0)
        .then((res)=>{
          console.log(res.data)
          this.Grouplist=res.data.queryResult
        })
      },500)
      this.centerDialogVisible=true
    },
    // 远处搜索
    remoteMethod(query){
      if(query!=''&&this.defaultGroupId){
        GroupDevices(this.defaultGroupId,1,1000,1,query)
        .then((res)=>{
          this.deviceslist=res.data.data.list
        })
      }else{
        GroupDevices(this.defaultGroupId,1,1000,1)
        .then((res)=>{
          this.deviceslist=res.data.data.list
        })
      }
    },
    //获取二级分组
    getGroupList2(val){
      this.defaultGroupId = val
      //每次选择一级分组清空二三级分组已经设备列表
      this.Groupinglist2=[]
      this.Groupinglist3=[]
      this.Grouping2=null
      this.Grouping3=null
      getAddLevel3Group(val)
      .then((res)=>{
        this.Groupinglist2=res.data.queryResult
      })
      GroupDevices(val,3,1000,1)
      .then((res)=>{
        this.deviceslist=res.data.data.list
      })
      // this.Grouplist.forEach(element => {
      //   if(element.group_id==this.Grouping1){
      //     this.Groupinglist2=element.groupList
      //     this.deviceslist=element.devices
      //   }
      // });
    },
    //获取三级分组
    getGroupList3(val){
      this.defaultGroupId = val
      //每次选择二级级分组清空三级分组已经设备列表
      this.Groupinglist3=[]
      this.Grouping3=null
      this.deviceslist=[]
      getAddLevel3Group(val)
      .then((res)=>{
        this.Groupinglist3=res.data.queryResult
      })
      GroupDevices(val,3,1000,1)
      .then((res)=>{
        this.deviceslist=res.data.data.list
      })
    },
    //获取三级分组下的设备
    getGroupList3devices(){
      this.Groupinglist3.forEach(element => {
        if(element.group_id==this.Grouping3){
          this.deviceslist=element.devices
        }
      })
    },
    //获取当前选中的固件文件
    getpackpz(){
      this.packlist.forEach((val,index,arr)=>{
        if(val.cfId==this.pack){
          this.uppack=val
        }
      })
    },
    //添加升级任务
    addLevelUp(){
      if(this.deviceslist.length==0){
        this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.please'),
          type: 'warning'
        });
        return
      }
      else if(this.pack==null){
        this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.File_Upload_Upgrader'),
          type: 'warning'
        });
        return
      }
        addConfig(this.addtaskname,this.addtaskms,this.deviceDid,this.uppack.cfPath,
        this.uppack.cfFileSize,this.uppack.cfId)
        .then((res)=>{
          if(res.data.code==0){
            this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.Dispatched'),
          type: 'success'
          })
          this.centerDialogVisible=!this.centerDialogVisible
          //添加完触发方法，刷新列表数据
          this.$emit('getupgradelist')
          }
          else {
            this.$message({
          showClose: true,
          message: this.$t('lang.taskDialog.operation'),
          type: 'warning'
        });
          }
        })
    }
  },
  mounted(){
    getAddLevel3Group(0)
        .then((res)=>{
          console.log(res.data)
          this.Grouplist=res.data.queryResult
        })
  }
};
</script>
<style scoped>
.dialog-con {
  text-align: center;
}
.adduserinput {
  display: inline-block;
  width: 50%;
  margin: 0.2rem;
}
.tetxp {
  display: inline-block;
  width: 2.7rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
</style>
